module.exports = __webpack_public_path__ + "media/img/help_center/Student_Message_04-efe0f0baf60be49a9de41883613a8d50.jpg";